import HttpStatus from 'http-status';
import * as authService from '../services/auth';
import * as tokenService from '../services/token';
import * as snapshotService from '../services/snapshot';

import http from '../utilities/http';
import { toast } from 'react-hot-toast';

const RETRY_COUNT_LIMIT = 1;
const TOKEN_EXPIRE = 'Token expired';
const AUTHORIZATION_HEADER = 'Authorization';
const SESSION_EXPIRE = 'Refresh token expired';
const REFRESH_TOKEN_DOESNT_EXIST = 'Invalid refresh token';
const SYNC_TIME = 'sync_time';
const IS_SNAPSHOT = 'is_snapshot';

/**
 * Build authorization header
 *
 * @param {string} accessToken
 * @returns {string}
 */
function buildAuthHeader(accessToken) {
  return `Bearer ${accessToken}`;
}

/**
 * Interceptor to add authentication header for all requests.
 *
 * @param {object} request
 * @returns {object}
 */
export function requestInterceptor(request) {
  const accessToken = tokenService.getAccessToken();
  const syncTime = snapshotService.getSyncTime();

  if (accessToken && !request.headers[AUTHORIZATION_HEADER]) {
    request.headers[AUTHORIZATION_HEADER] = buildAuthHeader(accessToken);
  }

  if (syncTime && !request.headers[IS_SNAPSHOT]) {
    request.headers[SYNC_TIME] = syncTime;
    request.headers[IS_SNAPSHOT] = 1;
  }

  return request;
}

/**
 * Interceptor to refresh access token.
 *
 * @param {object} error
 * @returns {object}
 */
export async function responseInterceptor(error) {
  if (!error.response) {
    return Promise.reject(error);
  }

  const originalRequest = error.config;

  const code = error?.response?.status;
  const message = error?.response?.data?.message;

  if (
    error.response.status === 400 ||
    error.response.status === 404 ||
    error.response.status === 500
  ) {
    // handle error 400, 404 and 500 request
    if (error.response.data.message) {
      toast.error(error.response.data.message);
    } else {
      toast.error('Something went wrong. Please again later.');
    }
  }

  if (
    code === HttpStatus.UNAUTHORIZED &&
    message === TOKEN_EXPIRE &&
    !originalRequest.__isRetryRequest
  ) {
    originalRequest._retry = true;
    originalRequest.retryCount = isNaN(originalRequest.retryCount)
      ? 1
      : originalRequest.retryCount++;

    const token = authService.refresh();

    // // attachAuthObserver() from init should handle it.
    // tokenService.setAccessToken(data.accessToken);

    originalRequest.headers[AUTHORIZATION_HEADER] = buildAuthHeader(token);

    return http.request(originalRequest);
  }

  if (
    code === HttpStatus.UNAUTHORIZED ||
    // code === HttpStatus.NOT_FOUND ||
    message === SESSION_EXPIRE ||
    message === REFRESH_TOKEN_DOESNT_EXIST ||
    originalRequest.retryCount > RETRY_COUNT_LIMIT
  ) {
    tokenService.clear();
    await authService.logout().then(() => {
      window.location = '/login';
    });
  }

  return Promise.reject(error);
}
